import React from 'react';
import WhatsAppButton from '../components/common/WhatsAppButton';
import ContactForm from '../components/contact/ContactForm';
import './PropertyDetailPage.css';

const PropertyDetailPage = ({ property }) => {
    if (!property) {
        return <div className="property-detail">Property not found.</div>;
    }

    return (
        <div className="property-detail">
            <h1>{property.title}</h1>
            <div className="property-images">
                {/* Main property image */}
                {property.image && (
                    <img
                        src={property.image}
                        alt={property.title}
                        className="main-property-image"
                        onError={e => { e.target.onerror = null; e.target.style.display = 'none'; }}
                    />
                )}
                {/* Additional property images */}
                {Array.isArray(property.additionalImages) && property.additionalImages.length > 0 &&
                    property.additionalImages.map((image, index) => (
                        image && (
                            <img
                                key={index}
                                src={image}
                                alt={`${property.title} - View ${index + 1}`}
                                onError={e => { e.target.onerror = null; e.target.style.display = 'none'; }}
                            />
                        )
                    ))
                }
            </div>
            <div className="property-info">
                <div className="info-section">
                    <h3>Quick Info</h3>
                    <p>Price: ${property.price}</p>
                    <p>Location: {property.location}</p>
                    <p>Property Type: {property.propertyType || property.type}</p>
                    <p>Size: {property.size}</p>
                </div>
                <div className="info-section">
                    <h3>Key Features</h3>
                    <ul className="features-list">
                        <li>Bedrooms: {property.bedrooms || 'N/A'}</li>
                        <li>Bathrooms: {property.bathrooms || 'N/A'}</li>
                        <li>Parking: {property.parking || 'N/A'}</li>
                        <li>Year Built: {property.yearBuilt || 'N/A'}</li>
                    </ul>
                </div>
            </div>
            <div className="property-description">
                <h2>About This Property</h2>
                <p>{property.description}</p>
            </div>
            <div className="contact-section">
                <h2>Interested in this property?</h2>
                <WhatsAppButton />
                <ContactForm />
            </div>
        </div>
    );
};

export default PropertyDetailPage;